define([
	"dojo/_base/declare",
	"csi/config/preferences",
	"csi/state/rootStore",
	"./_CalendarHierarchyActivities"
], function(declare, configPreferences, {routerStore}, _CalendarHierarchyActivities) {

	return declare(_CalendarHierarchyActivities, {
		/**
		 * @override
		 * If Root and first Relationship target the same class, then remove the path
		 */
		_resolveView() {
			const {cacheView, defView, relRoot} = this;
			const node = this.getViewNode();
			const container = cacheView.get(node?.__Parent__);
			const ap = relRoot.m_addPaths[0];

			if (routerStore.getBreadcrumbNode(ap.m_typeToFind)) {
				defView.m_root = null;
				ap.m_path = "";
				ap.m_pathParent = null;
			} else if (container) {
				defView.pathHints = `Calendar.${container.$Type}`;
				defView.pathHintsContext = configPreferences.getContextualPathHints(defView.pathHints);
			}

			this.inherited(arguments);
		}
	});
});